import { cableLogo, electricityLogo } from "@/constants";
import React from "react";

const CableTiles = () => {
  return (
    <div className="my-5">
      <div className="grid grid-cols-4 justify-between">
        {cableLogo.map((cable, index) => (
          <div key={index}>
            <div className="w-fit rounded-lg p-2">
              <img
                src={cable.img}
                alt="network-logo"
                className="size-16 rounded-lg object-contain"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CableTiles;
